import React from 'react'

const SvgFirefox = (props) => (
  <svg width={48} height={48} viewBox="0 0 84 84" {...props}>
    <defs>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={80.797}
        cy={-8515.121}
        cx={-7907.187}
        id="firefox_svg__b"
      >
        <stop stopColor="#ffbd4f" offset={0.129} />
        <stop stopColor="#ffac31" offset={0.186} />
        <stop stopColor="#ff9d17" offset={0.247} />
        <stop stopColor="#ff980e" offset={0.283} />
        <stop stopColor="#ff563b" offset={0.403} />
        <stop stopColor="#ff3750" offset={0.467} />
        <stop stopColor="#f5156c" offset={0.71} />
        <stop stopColor="#eb0878" offset={0.782} />
        <stop stopColor="#e50080" offset={0.86} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={80.797}
        cy={-8482.089}
        cx={-7936.711}
        id="firefox_svg__c"
      >
        <stop stopColor="#960e18" offset={0.3} />
        <stop stopOpacity={0.74} stopColor="#b11927" offset={0.351} />
        <stop stopOpacity={0.343} stopColor="#db293d" offset={0.435} />
        <stop stopOpacity={0.094} stopColor="#f5334b" offset={0.497} />
        <stop stopOpacity={0} stopColor="#ff3750" offset={0.53} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={58.534}
        cy={-8533.457}
        cx={-7926.97}
        id="firefox_svg__d"
      >
        <stop stopColor="#fff44f" offset={0.132} />
        <stop stopColor="#ffdc3e" offset={0.252} />
        <stop stopColor="#ff9d12" offset={0.506} />
        <stop stopColor="#ff980e" offset={0.526} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={38.471}
        cy={-8460.984}
        cx={-7945.648}
        id="firefox_svg__e"
      >
        <stop stopColor="#3a8ee6" offset={0.353} />
        <stop stopColor="#5c79f0" offset={0.472} />
        <stop stopColor="#9059ff" offset={0.669} />
        <stop stopColor="#c139e6" offset={1} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(.972 -.235 .275 1.138 10095.002 7833.794)"
        r={20.397}
        cy={-8491.546}
        cx={-7935.62}
        id="firefox_svg__f"
      >
        <stop stopOpacity={0} stopColor="#9059ff" offset={0.206} />
        <stop stopOpacity={0.064} stopColor="#8c4ff3" offset={0.278} />
        <stop stopOpacity={0.45} stopColor="#7716a8" offset={0.747} />
        <stop stopOpacity={0.6} stopColor="#6e008b" offset={0.975} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={27.676}
        cy={-8518.427}
        cx={-7937.731}
        id="firefox_svg__g"
      >
        <stop stopColor="#ffe226" offset={0} />
        <stop stopColor="#ffdb27" offset={0.121} />
        <stop stopColor="#ffc82a" offset={0.295} />
        <stop stopColor="#ffa930" offset={0.502} />
        <stop stopColor="#ff7e37" offset={0.732} />
        <stop stopColor="#ff7139" offset={0.792} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={118.081}
        cy={-8535.981}
        cx={-7915.977}
        id="firefox_svg__h"
      >
        <stop stopColor="#fff44f" offset={0.113} />
        <stop stopColor="#ff980e" offset={0.456} />
        <stop stopColor="#ff5634" offset={0.622} />
        <stop stopColor="#ff3647" offset={0.716} />
        <stop stopColor="#e31587" offset={0.904} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(.105 .995 -.653 .069 -4680.304 8470.187)"
        r={86.499}
        cy={-8522.859}
        cx={-7927.165}
        id="firefox_svg__i"
      >
        <stop stopColor="#fff44f" offset={0} />
        <stop stopColor="#ffe847" offset={0.06} />
        <stop stopColor="#ffc830" offset={0.168} />
        <stop stopColor="#ff980e" offset={0.304} />
        <stop stopColor="#ff8b16" offset={0.356} />
        <stop stopColor="#ff672a" offset={0.455} />
        <stop stopColor="#ff3647" offset={0.57} />
        <stop stopColor="#e31587" offset={0.737} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={73.72}
        cy={-8508.176}
        cx={-7938.383}
        id="firefox_svg__j"
      >
        <stop stopColor="#fff44f" offset={0.137} />
        <stop stopColor="#ff980e" offset={0.48} />
        <stop stopColor="#ff5634" offset={0.592} />
        <stop stopColor="#ff3647" offset={0.655} />
        <stop stopColor="#e31587" offset={0.904} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7978.7 8523.996)"
        r={80.686}
        cy={-8503.861}
        cx={-7918.923}
        id="firefox_svg__k"
      >
        <stop stopColor="#fff44f" offset={0.094} />
        <stop stopColor="#ffe141" offset={0.231} />
        <stop stopColor="#ffaf1e" offset={0.509} />
        <stop stopColor="#ff980e" offset={0.626} />
      </radialGradient>
      <linearGradient
        gradientTransform="translate(3.7 -.004)"
        gradientUnits="userSpaceOnUse"
        y2={74.468}
        x2={6.447}
        y1={12.393}
        x1={70.786}
        id="firefox_svg__a"
      >
        <stop stopColor="#fff44f" offset={0.048} />
        <stop stopColor="#ffe847" offset={0.111} />
        <stop stopColor="#ffc830" offset={0.225} />
        <stop stopColor="#ff980e" offset={0.368} />
        <stop stopColor="#ff8b16" offset={0.401} />
        <stop stopColor="#ff672a" offset={0.462} />
        <stop stopColor="#ff3647" offset={0.534} />
        <stop stopColor="#e31587" offset={0.705} />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(3.7 -.004)"
        gradientUnits="userSpaceOnUse"
        y2={66.806}
        x2={15.267}
        y1={12.061}
        x1={70.013}
        id="firefox_svg__l"
      >
        <stop stopOpacity={0.8} stopColor="#fff44f" offset={0.167} />
        <stop stopOpacity={0.634} stopColor="#fff44f" offset={0.266} />
        <stop stopOpacity={0.217} stopColor="#fff44f" offset={0.489} />
        <stop stopOpacity={0} stopColor="#fff44f" offset={0.6} />
      </linearGradient>
    </defs>
    <path
      d="M79.616 26.827c-1.684-4.052-5.1-8.427-7.775-9.81a40.266 40.266 0 013.925 11.764l.007.065C71.391 17.92 63.96 13.516 57.891 3.924a47.099 47.099 0 01-.913-1.484 12.24 12.24 0 01-.427-.8 7.053 7.053 0 01-.578-1.535.1.1 0 00-.088-.1.138.138 0 00-.073 0c-.005 0-.013.009-.019.01l-.028.016.015-.026c-9.735 5.7-13.038 16.252-13.342 21.53a19.387 19.387 0 00-10.666 4.11 11.587 11.587 0 00-1-.757 17.968 17.968 0 01-.109-9.473 28.705 28.705 0 00-9.329 7.21h-.018c-1.536-1.947-1.428-8.367-1.34-9.708a6.928 6.928 0 00-1.294.687 28.225 28.225 0 00-3.788 3.245 33.845 33.845 0 00-3.623 4.347v.006-.007a32.733 32.733 0 00-5.2 11.743l-.052.256a61.89 61.89 0 00-.381 2.42c0 .029-.006.056-.009.085A36.937 36.937 0 005 41.042v.2a38.759 38.759 0 0076.954 6.554c.065-.5.118-.995.176-1.5a39.857 39.857 0 00-2.514-19.47zm-44.67 30.338c.181.087.351.18.537.264l.027.017q-.282-.135-.564-.281zm8.878-23.376zm31.952-4.934v-.037l.007.04z"
      fill="url(#firefox_svg__a)"
    />
    <path
      d="M79.616 26.827c-1.684-4.052-5.1-8.427-7.775-9.81a40.266 40.266 0 013.925 11.764v.037l.007.04a35.1 35.1 0 01-1.206 26.159c-4.442 9.53-15.194 19.3-32.024 18.825-18.185-.515-34.2-14.01-37.194-31.683-.545-2.787 0-4.2.274-6.465A28.876 28.876 0 005 41.042v.2a38.759 38.759 0 0076.954 6.554c.065-.5.118-.995.176-1.5a39.857 39.857 0 00-2.514-19.47z"
      fill="url(#firefox_svg__b)"
    />
    <path
      d="M79.616 26.827c-1.684-4.052-5.1-8.427-7.775-9.81a40.266 40.266 0 013.925 11.764v.037l.007.04a35.1 35.1 0 01-1.206 26.159c-4.442 9.53-15.194 19.3-32.024 18.825-18.185-.515-34.2-14.01-37.194-31.683-.545-2.787 0-4.2.274-6.465A28.876 28.876 0 005 41.042v.2a38.759 38.759 0 0076.954 6.554c.065-.5.118-.995.176-1.5a39.857 39.857 0 00-2.514-19.47z"
      fill="url(#firefox_svg__c)"
    />
    <path
      d="M60.782 31.383c.084.059.162.118.241.177a21.1 21.1 0 00-3.6-4.695C45.377 14.817 54.266.742 55.765.027l.015-.022c-9.735 5.7-13.038 16.252-13.342 21.53.452-.031.9-.07 1.362-.07a19.56 19.56 0 0116.982 9.918z"
      fill="url(#firefox_svg__d)"
    />
    <path
      d="M43.825 33.789c-.064.964-3.47 4.289-4.661 4.289-11.021 0-12.81 6.667-12.81 6.667.488 5.614 4.4 10.238 9.129 12.684.216.112.435.213.654.312q.569.252 1.138.466a17.235 17.235 0 005.043.973c19.317.906 23.059-23.1 9.119-30.066a13.38 13.38 0 019.345 2.269A19.56 19.56 0 0043.8 21.466c-.46 0-.91.038-1.362.069a19.387 19.387 0 00-10.666 4.11c.591.5 1.258 1.169 2.663 2.554 2.63 2.59 9.375 5.275 9.39 5.59z"
      fill="url(#firefox_svg__e)"
    />
    <path
      d="M43.825 33.789c-.064.964-3.47 4.289-4.661 4.289-11.021 0-12.81 6.667-12.81 6.667.488 5.614 4.4 10.238 9.129 12.684.216.112.435.213.654.312q.569.252 1.138.466a17.235 17.235 0 005.043.973c19.317.906 23.059-23.1 9.119-30.066a13.38 13.38 0 019.345 2.269A19.56 19.56 0 0043.8 21.466c-.46 0-.91.038-1.362.069a19.387 19.387 0 00-10.666 4.11c.591.5 1.258 1.169 2.663 2.554 2.63 2.59 9.375 5.275 9.39 5.59z"
      fill="url(#firefox_svg__f)"
    />
    <path
      d="M29.965 24.357c.314.2.573.374.8.53a17.968 17.968 0 01-.109-9.472 28.705 28.705 0 00-9.329 7.21c.189-.005 5.811-.106 8.638 1.732z"
      fill="url(#firefox_svg__g)"
    />
    <path
      d="M5.354 42.159c2.991 17.674 19.009 31.168 37.194 31.683 16.83.476 27.582-9.294 32.024-18.825a35.1 35.1 0 001.206-26.158v-.037c0-.03-.006-.046 0-.037l.007.065c1.375 8.977-3.191 17.674-10.329 23.555l-.022.05c-13.908 11.327-27.218 6.834-29.912 5q-.282-.135-.564-.281c-8.109-3.876-11.459-11.264-10.741-17.6a9.953 9.953 0 01-9.181-5.775 14.618 14.618 0 0114.249-.572 19.3 19.3 0 0014.552.572c-.015-.315-6.76-3-9.39-5.59-1.405-1.385-2.072-2.052-2.663-2.553a11.587 11.587 0 00-1-.758c-.23-.157-.489-.327-.8-.531-2.827-1.838-8.449-1.737-8.635-1.732h-.018c-1.536-1.947-1.428-8.367-1.34-9.708a6.928 6.928 0 00-1.294.687 28.225 28.225 0 00-3.788 3.245 33.845 33.845 0 00-3.638 4.337v.006-.007a32.733 32.733 0 00-5.2 11.743c-.019.079-1.396 6.099-.717 9.22z"
      fill="url(#firefox_svg__h)"
    />
    <path
      d="M57.425 26.865a21.1 21.1 0 013.6 4.7c.213.16.412.32.581.476 8.787 8.1 4.183 19.55 3.84 20.365 7.138-5.881 11.7-14.578 10.329-23.555C71.391 17.92 63.96 13.516 57.891 3.924a47.099 47.099 0 01-.913-1.484 12.24 12.24 0 01-.427-.8 7.053 7.053 0 01-.578-1.535.1.1 0 00-.088-.1.138.138 0 00-.073 0c-.005 0-.013.009-.019.01l-.028.016c-1.499.71-10.388 14.786 1.66 26.834z"
      fill="url(#firefox_svg__i)"
    />
    <path
      d="M61.6 32.036a8.083 8.083 0 00-.581-.476 7.915 7.915 0 00-.241-.177 13.38 13.38 0 00-9.345-2.27c13.94 6.97 10.2 30.973-9.119 30.067a17.235 17.235 0 01-5.043-.973q-.569-.213-1.138-.466c-.219-.1-.438-.2-.654-.312l.027.017c2.694 1.839 16 6.332 29.912-5l.022-.05c.347-.81 4.951-12.263-3.84-20.36z"
      fill="url(#firefox_svg__j)"
    />
    <path
      d="M26.354 44.745s1.789-6.667 12.81-6.667c1.191 0 4.6-3.325 4.661-4.29a19.3 19.3 0 01-14.552-.571 14.618 14.618 0 00-14.249.572 9.953 9.953 0 009.181 5.775c-.718 6.337 2.632 13.725 10.741 17.6.181.087.351.18.537.264-4.733-2.445-8.641-7.07-9.129-12.683z"
      fill="url(#firefox_svg__k)"
    />
    <path
      d="M79.616 26.827c-1.684-4.052-5.1-8.427-7.775-9.81a40.266 40.266 0 013.925 11.764l.007.065C71.391 17.92 63.96 13.516 57.891 3.924a47.099 47.099 0 01-.913-1.484 12.24 12.24 0 01-.427-.8 7.053 7.053 0 01-.578-1.535.1.1 0 00-.088-.1.138.138 0 00-.073 0c-.005 0-.013.009-.019.01l-.028.016.015-.026c-9.735 5.7-13.038 16.252-13.342 21.53.452-.031.9-.07 1.362-.07a19.56 19.56 0 0116.982 9.918 13.38 13.38 0 00-9.345-2.27c13.94 6.97 10.2 30.973-9.119 30.067a17.235 17.235 0 01-5.043-.973q-.569-.213-1.138-.466c-.219-.1-.438-.2-.654-.312l.027.017q-.282-.135-.564-.281c.181.087.351.18.537.264-4.733-2.446-8.641-7.07-9.129-12.684 0 0 1.789-6.667 12.81-6.667 1.191 0 4.6-3.325 4.661-4.29-.015-.314-6.76-3-9.39-5.59-1.405-1.384-2.072-2.051-2.663-2.552a11.587 11.587 0 00-1-.758 17.968 17.968 0 01-.109-9.473 28.705 28.705 0 00-9.329 7.21h-.018c-1.536-1.947-1.428-8.367-1.34-9.708a6.928 6.928 0 00-1.294.687 28.225 28.225 0 00-3.788 3.245 33.845 33.845 0 00-3.623 4.347v.006-.007a32.733 32.733 0 00-5.2 11.743l-.052.256c-.073.34-.4 2.073-.447 2.445 0 .028 0-.03 0 0A45.094 45.094 0 005 41.042v.2a38.759 38.759 0 0076.954 6.554c.065-.5.118-.995.176-1.5a39.857 39.857 0 00-2.514-19.47zm-3.845 1.99l.007.042z"
      fill="url(#firefox_svg__l)"
    />
  </svg>
)

export default SvgFirefox
